@layer reset, default, desktop, mobile;

@layer reset {
  :host {
    display: block;

    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
  }
}

@layer default {
  :host {
    width: 100%;

    .gcds-side-nav__heading {
      font: var(--gcds-side-nav-heading-font);
      margin-block-end: var(--gcds-side-nav-heading-margin);
      padding: var(--gcds-side-nav-heading-padding);
    }
  }
}

/* Note: viewport specific style decision */
@layer desktop {
  :host .gcds-side-nav {
    @media only screen and (width >= 64em) {
      max-width: var(--gcds-side-nav-max-width);
    }
  }
}

/* Note: viewport specific style decision */
@layer mobile {
  @media only screen and (width < 64em) {
    :host {
      .gcds-side-nav__heading {
        display: block;
        width: 0;
        height: 0;
        margin: 0;
        padding: 0;
        overflow: hidden;
      }
    }
  }
}
